/** @flow */

import type { StaffGroupsState } from "./types";

export const initialState: StaffGroupsState = {
  requestsInProgress: 0,
  list: {
    content: [],
    totalElements: 0,
  },
  modals: {
    staffGroupId: null,
    name: null,
    numberEmployees: null,
    disable: {
      visible: false,
    },
    reassign: {
      visible: false,
    },
    addStaffGroup: {
      visible: false,
    },
    editStaffGroup: {
      visible: false,
      formData: {},
    },
  },
  configuration: {
    staffGroupsEnabled: null,
  },
  schema: {
    staffGroup: null,
    staffGroups: null,
  },
  totalList: [],
  error: null,
};

export default initialState;
